import React, { useState } from "react";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import { Helmet } from "react-helmet";
import { FaBook, FaArchive, FaSearch, FaExternalLinkAlt } from "react-icons/fa";
import { PiAirplaneTiltFill } from "react-icons/pi";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import "./milestones.css";

function Milestones() {
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 2019 + 1 },
    (_, i) => 2019 + i
  );

  const [rowsType, setRowsType] = useState("");
  const [year, setYear] = useState(currentYear);
  const [awb, setAwb] = useState("");
  const [transfer, setTransfer] = useState("");
  const [activeIcons, setActiveIcons] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [tableData, setTableData] = useState([]);
  const [noDataFound, setNoDataFound] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [flightNumber, setFlightNumber] = useState("");

  const handleToggleIcon = (index) => {
    const updated = [...activeIcons];
    updated[index] = !updated[index];
    setActiveIcons(updated);
  };

  const handleFlightChange = (e) => {
    const input = e.target.value;
    const formatted = formatFlight(input);
    setFlightNumber(formatted);
  };

  const formatFlight = (value) => {
    const regex = /^([A-Z]{2})(\d{1,4})\/(\d{2})([A-Z]{3})$/i;
    const match = value.toUpperCase().match(regex);
    if (!match) return value.toUpperCase();
    const [, airline, number, day, month] = match;
    const paddedNumber = number.padStart(4, "0");
    return `${airline}${paddedNumber}/${day}${month.toUpperCase()}`;
  };

  const handleAwbChange = (e) => {
    let value = e.target.value.replace(/\s+/g, "").replace(/[^0-9]/g, "");
    if (value.length > 11) return;
    if (value.length > 3) {
      value = `${value.slice(0, 3)}-${value.slice(3)}`;
    }
    setAwb(value);
  };

  const handleAplicar = () => {
    const isValidSearch =
      flightNumber !== "" && awb !== "" && rowsType !== "" && transfer !== "";

    if (!isValidSearch) {
      setTableData([]);
      setShowTable(false);
      setNoDataFound(true);
      return;
    }

    // Mapeo de opciones seleccionadas
    const transferText =
      transfer === "opt1"
        ? "INTERLINEAL"
        : transfer === "opt2"
        ? "TRÁNSITO"
        : "";

    setTableData([
      {
        id: 1,
        flight_dep: flightNumber,
        awb: awb,
        transfer: transferText,
        year,
        pieces: "10",
        weight: "500",
        shc: "Carga general",
        origin: "MEX",
        destination: "JFK",
        flight_arr: "AM456/10SEP",
        ata: "10:30",
        etd: "12:45",
        description: "GENERAL",
        sem: "30",
        status_checkin: true,
        status_document: false,
        status_confronta: false,
        status_xray: false,
        status_location: false,
      },
    ]);
    setShowTable(true);
    setNoDataFound(false);
  };

  const handleTodo = () => {
    setTableData([
      {
        id: 1,
        flight_dep: "AM1234/25MAY",
        awb: "139-11112222",
        transfer: "TRÁNSITO",
        year,
        pieces: "10",
        weight: "500",
        shc: "Carga general",
        origin: "MEX",
        destination: "JFK",
        flight_arr: "AM456/10SEP",
        ata: "10:30",
        etd: "12:45",
        description: "GENERAL",
        status: "30",
        //Estados para los iconos
        status_checkin: true,
        status_document: false,
        status_confronta: false,
        status_xray: false,
        status_location: false,
      },
      {
        id: 2,
        flight_dep: "AM5678/26MAY",
        awb: "139-33334444",
        transfer: "INTERLINEAL",
        year,
        pieces: "12",
        weight: "600",
        shc: "Carga general",
        origin: "CUN",
        destination: "ORD",
        flight_arr: "AM789/25AGO",
        ata: "14:00",
        etd: "16:30",
        description: "CONSOL",
        sem: "31",
        //Estados para los iconos
        status_checkin: true,
        status_document: true,
        status_confronta: true,
        status_xray: false,
        status_location: false,
      },
      {
        id: 3,
        flight_dep: "AM5678/26MAY",
        awb: "139-48176844",
        transfer: "INTERLINEAL",
        year,
        pieces: "408",
        weight: "800",
        shc: "Perecedero",
        origin: "MTY",
        destination: "GDL",
        flight_arr: "AM0057/09JUN",
        ata: "07:20",
        etd: "22:00",
        description: "CONSOL",
        sem: "31",
        //Estados para los iconos
        status_checkin: false,
        status_document: false,
        status_confronta: false,
        status_xray: false,
        status_location: false,
      },
      {
        id: 4,
        flight_dep: "QR0804/10JUN",
        awb: "157-99987403",
        transfer: "INTERLINEAL",
        year,
        pieces: "8",
        weight: "1075.5",
        shc: "Carga general",
        origin: "MTY",
        destination: "DMM",
        flight_arr: "AM0959/07JUN",
        ata: "22:10",
        etd: "22:00",
        description: "ELECTRICAL PART",
        sem: "31",
        //Estados para los iconos
        status_checkin: true,
        status_document: false,
        status_confronta: false,
        status_xray: false,
        status_location: false,
      },
      {
        id: 5,
        flight_dep: "AM0761/12JUN",
        awb: "139-90544425",
        transfer: "TRÁNSITO",
        year,
        pieces: "1",
        weight: "192.8",
        shc: "-",
        origin: "MTY",
        destination: "BOG",
        flight_arr: "AM0955/11JUN",
        ata: "-",
        etd: "09:15",
        description: "RESTO HUMANO",
        sem: "31",
        //Estados para los iconos
        status_checkin: true,
        status_document: true,
        status_confronta: true,
        status_xray: true,
        status_location: false,
      },
    ]);
    setShowTable(true);
    setNoDataFound(false);

    // Reset form
    setFlightNumber("");
    setAwb("");
    setTransfer("");
    setRowsType("");
    setYear(currentYear);
  };

  const getSemaforoColor = (semValue) => {
    const num = parseInt(semValue);
    if (num < 20) return "rojo";
    if (num < 40) return "amarillo";
    return "verde";
  };

  const handleDownloadReport = async () => {
    if (tableData.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Reporte");

    const columns = [
      { header: "ESTATUS", key: "sem", width: 12 },
      { header: "MASTER", key: "awb", width: 20 },
      { header: "PIEZAS", key: "pieces", width: 10 },
      { header: "PESO", key: "weight", width: 10 },
      { header: "SHC", key: "shc", width: 20 },
      { header: "ORIGEN", key: "origin", width: 10 },
      { header: "DESTINO", key: "destination", width: 10 },
      { header: "VUELO LLEGADA", key: "flight_arr", width: 18 },
      { header: "VUELO SALIDA", key: "flight_dep", width: 18 },
      { header: "ETD", key: "etd", width: 10 },
      { header: "DESCRIPCIÓN", key: "description", width: 20 },
      { header: "ATA", key: "ata", width: 10 },
      { header: "T. TRANSFERENCIA", key: "transfer", width: 20 },
      { header: "CHECKIN", key: "status_checkin", width: 10 },
      { header: "OBSERVACIONES CHECKIN", key: "obs_checkin", width: 25 },
      { header: "DOCUMENTACIÓN", key: "status_document", width: 15 },
      { header: "ORIGINALES/COPIA", key: "originales_copia", width: 18 },
      { header: "OBSERVACIONES DOCUMENTACIÓN", key: "obs_doc", width: 25 },
      { header: "CONFRONTA", key: "status_confronta", width: 12 },
      { header: "PIEZAS CONFRONTA", key: "piezas_confronta", width: 15 },
      { header: "PESO CONFRONTA", key: "peso_confronta", width: 15 },
      {
        header: "PIEZAS TOTALES CONFRONTA",
        key: "piezas_totales_confronta",
        width: 20,
      },
      {
        header: "PESO TOTAL CONFRONTA",
        key: "peso_total_confronta",
        width: 20,
      },
      { header: "OBSERVACIONES CONFRONTA", key: "obs_confronta", width: 25 },
      { header: "RAYOS X-ETD", key: "xray_etd", width: 15 },
      { header: "RAYOS X", key: "status_xray", width: 12 },
      { header: "OBSERVACIONES RAYOS X", key: "obs_xray", width: 25 },
      { header: "ASIGNACIÓN LOCACIÓN", key: "status_location", width: 20 },
      { header: "LOCACIÓN", key: "location", width: 15 },
      { header: "OBSERVACIONES LOCACIÓN", key: "obs_location", width: 25 },
      { header: "PUNTOS TÁCTICOS", key: "puntos_tacticos", width: 20 },
    ];

    worksheet.columns = columns;

    worksheet.getRow(1).eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF0E2240" },
      };
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = { horizontal: "center" };
    });

    tableData.forEach((row) => {
      worksheet.addRow({
        sem: row.sem || row.status || "-",
        awb: row.awb || "-",
        pieces: row.pieces ?? "-",
        weight: row.weight ?? "-",
        shc: row.shc || "-",
        origin: row.origin || "-",
        destination: row.destination || "-",
        flight_arr: row.flight_arr || "-",
        flight_dep: row.flight_dep || "-",
        etd: row.etd || "-",
        description: row.description || "-",
        ata: row.ata || "-",
        transfer: row.transfer || "-",
        status_checkin: row.status_checkin ? row.status_checkin : "-",
        obs_checkin: row.obs_checkin || "-",
        status_document: row.status_document ? row.status_document : "-",
        originales_copia: row.originales_copia || "-",
        obs_doc: row.obs_doc || "-",
        status_confronta: row.status_confronta ? row.status_confronta : "-",
        piezas_confronta: row.piezas_confronta ?? "-",
        peso_confronta: row.peso_confronta ?? "-",
        piezas_totales_confronta: row.piezas_totales_confronta ?? "-",
        peso_total_confronta: row.peso_total_confronta ?? "-",
        obs_confronta: row.obs_confronta || "-",
        xray_etd: row.xray_etd || "-",
        status_xray: row.status_xray ? row.status_xray : "-",
        obs_xray: row.obs_xray || "-",
        status_location: row.status_location ? row.status_location : "-",
        location: row.location || "-",
        obs_location: row.obs_location || "-",
        puntos_tacticos: row.puntos_tacticos || "-",
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "reporte_milestones.xlsx");
  };

  return (
    <>
      <Helmet>
        <title>Horus | Milestones</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid py-3 px-4">
        {/* Fila de opciones */}
        <div className="row gx-3 gy-4 mb-4 justify-content-center">
          <div className="col-12">
            <div className="row gx-2 gy-3">
              <div className="col-lg-2 col-md-4">
                <div className="p-2">
                  <div className="form-check d-flex align-items-center justify-content-between">
                    <label
                      htmlFor="radioTransitos"
                      className="form-check-label"
                    >
                      Tránsitos
                    </label>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="rowsType"
                      id="radioTransitos"
                      value="1"
                      checked={rowsType === "1"}
                      onChange={(e) => setRowsType(e.target.value)}
                    />
                  </div>
                  <div className="form-check d-flex align-items-center justify-content-between mt-2">
                    <label htmlFor="radioMex" className="form-check-label">
                      MEX
                    </label>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="rowsType"
                      id="radioMex"
                      value="2"
                      checked={rowsType === "2"}
                      onChange={(e) => setRowsType(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-2 col-md-4 text-center">
                <label className="form-label">Año</label>
                <select
                  className="form-select"
                  value={year}
                  onChange={(e) => setYear(parseInt(e.target.value))}
                >
                  {years.map((yr) => (
                    <option key={yr} value={yr}>
                      {yr}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-lg-3 col-md-4 text-center">
                <label className="form-label">Vuelo de salida</label>
                <input
                  type="text"
                  className="form-control"
                  value={flightNumber}
                  onChange={handleFlightChange}
                  maxLength={12}
                />
              </div>

              <div className="col-lg-3 col-md-4 text-center">
                <label className="form-label">Master</label>
                <input
                  type="text"
                  className="form-control"
                  value={awb}
                  onChange={handleAwbChange}
                />
              </div>

              <div className="col-lg-2 col-md-6 col-sm-12 text-center">
                <label className="form-label">T.Transferencia</label>
                <select
                  className="form-select"
                  value={transfer}
                  onChange={(e) => setTransfer(e.target.value)}
                >
                  <option value="" disabled>
                    Selecciona...
                  </option>
                  <option value="opt1">INTERLINEAL</option>
                  <option value="opt2">TRÁNSITO</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Botones */}
        <div className="row justify-content-center mb-4">
          <div className="col-md-8 d-flex justify-content-center gap-3 flex-wrap">
            <button className="btnn" onClick={handleAplicar}>
              Aplicar
            </button>
            <button className="btnn" onClick={handleTodo}>
              Todo
            </button>
            <button className="btnn" onClick={handleDownloadReport}>
              Descargar Reporte
            </button>
          </div>
        </div>

        {/* Íconos */}
        <div className="row justify-content-center mt-4 mb-4">
          <div className="col-md-3 d-flex justify-content-around">
            {[
              PiAirplaneTiltFill,
              FaBook,
              FaArchive,
              FaSearch,
              FaExternalLinkAlt,
            ].map((Icon, index) => (
              <Icon
                key={index}
                size={20}
                style={{
                  cursor: "pointer",
                  color: activeIcons[index] ? "#0E2240" : "#B0B0B0",
                  transition: "color 0.3s ease",
                }}
                onClick={() => handleToggleIcon(index)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Tabla de resultados */}
      {showTable && tableData.length > 0 ? (
        <div className="table-container">
          <table className="table fondo-headMilestones table-sm align-middle">
            <thead>
              <tr>
                <th>Progreso</th>
                <th>Guía</th>
                <th>Piezas</th>
                <th>Peso</th>
                <th>SHC</th>
                <th>Origen</th>
                <th>Destino</th>
                <th>Vuelo llegada</th>
                <th>ATA</th>
                <th>Vuelo salida</th>
                <th>ETD</th>
                <th>Descripción</th>
                <th>Sem</th>
                <th>T. Transfer</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {tableData.map((row, idx) => (
                <tr key={idx}>
                  <td className="icon-cell">
                    <div className="icon-wrapper d-flex gap-1 justify-content-center">
                      <PiAirplaneTiltFill
                        color={row.status_checkin ? "#0E2240" : "#B0B0B0"}
                        title="Check-in"
                      />
                      <FaBook
                        color={row.status_document ? "#0E2240" : "#B0B0B0"}
                        title="Documentación"
                      />
                      <FaArchive
                        color={row.status_confronta ? "#0E2240" : "#B0B0B0"}
                        title="Confronta"
                      />
                      <FaSearch
                        color={row.status_xray ? "#0E2240" : "#B0B0B0"}
                        title="X-ray"
                      />
                      <FaExternalLinkAlt
                        color={row.status_location ? "#0E2240" : "#B0B0B0"}
                        title="Ubicación"
                      />
                    </div>
                  </td>
                  <td>{row.awb}</td>
                  <td>{row.pieces || "-"}</td>
                  <td>{row.weight || "-"}</td>
                  <td className="shc-wrap">{row.shc || "-"}</td>
                  <td>{row.origin || "-"}</td>
                  <td>{row.destination || "-"}</td>
                  <td>{row.flight_arr || "-"}</td>
                  <td>{row.ata || "-"}</td>
                  <td>{row.flight_dep}</td>
                  <td>{row.etd || "-"}</td>
                  <td>{row.description || "-"}</td>
                  <td>
                    <span
                      className={`semaforo ${getSemaforoColor(row.status)}`}
                    ></span>
                  </td>
                  <td>{row.transfer}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : noDataFound ? (
        <div className="text-center mt-4">
          <p className="alert alert-danger text-danger fw-bold">
            No se encontraron datos
          </p>
        </div>
      ) : null}
    </>
  );
}

export default Milestones;
